// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_footer_privacy_policy = /** @type {(inputs: {}) => string} */ () => {
	return `Privacy Policy`
};

const el_footer_privacy_policy = /** @type {(inputs: {}) => string} */ () => {
	return `Πολιτική Απορρήτου`
};

const ru_footer_privacy_policy = /** @type {(inputs: {}) => string} */ () => {
	return `Политика конфиденциальности`
};

const he_footer_privacy_policy = /** @type {(inputs: {}) => string} */ () => {
	return `מדיניות פרטיות`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer_privacy_policy = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_privacy_policy(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_privacy_policy", locale)
	if (locale === "en") return en_footer_privacy_policy(inputs)
	if (locale === "el") return el_footer_privacy_policy(inputs)
	if (locale === "ru") return ru_footer_privacy_policy(inputs)
	if (locale === "he") return he_footer_privacy_policy(inputs)
	return "footer_privacy_policy"
};